<template>
  <div id="serve">
    <iframe :src="serveSrc" @load="onIframeLoad"></iframe>
  </div>
</template>
<script>
import { SERVERTAPI } from "@/config";

export default {
  data() {
    return {
      // userInfo: {},
      apiSrc: SERVERTAPI,
      serveSrc: '',
      xy_script: ''
    }
  },
  // async created() {
  //   // 获取用户信息
  //   await this.$http.getmyindex().then(res => {
  //     this.userInfo = res.data?.info
  //     localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
  //   });
  //   console.log(this.userInfo);
  //   this.$http.getServe().then(res => {
  //     if (res.code === 0) {
  //       this.xy_script = res.data.xy_script;
  //       this.serveSrc = `/m/chatlink.html?eid=${this.xy_script}&language=en&metadata={'name': '${this.userInfo?.username}', 'tel':'${this.userInfo?.tel}}'`;
  //     } else {
  //       // this.serveSrc = this.apiSrc + `/chatlink.html?eid='&language=en&metadata={'name': '${this.userInfo.username}', 'tel':'${this.userInfo.tel}}'`;
  //       this.$toast(res.info);
  //     }
  //   })
  // }
  // async created() {
  //   this.$store.commit('SET_LOADING', true);
  //   try {
  //     // 获取用户信息
  //     const res = await this.$http.getmyindex();
  //     if (res.code !== -1) {
  //       this.userInfo = res.data?.info;
  //       localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
  //     }
  //     // 获取服务信息
  //     const serveRes = await this.$http.getServe();
  //     if (serveRes.code === 0) {
  //       console.log(serveRes.data.xy_script + '111111');
  //       this.xy_script = serveRes.data.xy_script;
  //       this.serveSrc = `/m/chatlink.html?eid=${this.xy_script}&language=en&metadata={'name': '${this.userInfo?.username || 'no login'}', 'tel':'${this.userInfo?.tel || ''}}'`;
  //       console.log(this.serveSrc);

  //       // 倒计时
  //       setTimeout(() => {
  //         this.$store.commit('SET_LOADING', false);
  //       }, 2000);
  //     } else {
  //       this.$toast(serveRes.info);
  //     }
  //   } catch (error) {
  //     // 处理错误情况
  //     console.error(error);
  //     this.$toast(error.message || 'An error occurred');
  //   }
  // }
  //   async created() {
  //     this.$store.commit('SET_LOADING', true);
  //     try {
  //       // 获取用户信息
  //       const res = await this.$http.getmyindex();
  //       if (res.code !== -1) {
  //         this.userInfo = res.data?.info;
  //         localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
  //         this.serveSrc = `https://www.netflixmoi.com/m/chatlink.html?language=en&metadata={'name': '${this.userInfo?.username || 'no login'}', 'tel':'${this.userInfo?.tel || ''}}'`;
  //         // 倒计时
  //         setTimeout(() => {
  //           this.$store.commit('SET_LOADING', false);
  //         }, 2000);
  //       }
  //     } catch (error) {
  //       // 处理错误情况
  //       console.error(error);
  //       this.$toast(error.message || 'An error occurred');
  //     }
  //   }
  // }
  created() {
    // 打开加载
    this.$store.commit('SET_LOADING', true);
    let userInfo = null;
    try {
      userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    } catch (e) {
      userInfo = null;
    }

    const clientId = String(userInfo?.id) + String(userInfo?.id) || "";
    const metadataObj = {
      name: userInfo?.username || "noLogin",
      tel: userInfo?.tel || ""
    };
    console.log(metadataObj);
    if (userInfo?.id) {
      const params = new URLSearchParams({
        language: "en",
        clientId,
        metadata: JSON.stringify(metadataObj),
      });
      this.serveSrc = `/chatlink.html?${params.toString()}`;
    } else {
      const params = new URLSearchParams({
        language: "en",
        metadata: JSON.stringify(metadataObj),
      });
      this.serveSrc = `/chatlink.html?${params.toString()}`;
    }
    console.log(this.serveSrc);

    // 开发环境
    // if (process.env.NODE_ENV === 'development') {
    //   this.serveSrc = 'http://netflixmoi.com/' + this.serveSrc;
    // }
  },
  methods: {
    onIframeLoad(e) {
      // 倒计时
      setTimeout(() => {
        this.$store.commit('SET_LOADING', false);
      }, 3000);
    }
  }
}
</script>
<style scoped>
iframe {
  width: 100%;
  min-height: 100vh;
  border: none;
  padding: 0;
}
</style>
